import React, { FC } from 'react';
import { Notification } from 'src/shared/services/NotificationService';
import { ToastMessage } from '../ToastMessage';

export interface NotificationsManagerProps {
  notifications: Notification[];
}

export const NotificationsManager: FC<NotificationsManagerProps> = ({
  notifications,
}) => {
  return (
    <section className="notifications-manager">
      {renderMessages(notifications)}
    </section>
  );
};

function renderMessages(notifications: Notification[] = []): JSX.Element[] {
  return notifications?.map((notification: Notification) => {
    return (
      <ToastMessage
        key={notification.id}
        type={notification.type}
        hideCloseButton
        stackable
      >
        {notification.text}
      </ToastMessage>
    );
  });
}

NotificationsManager.displayName = 'NotificationsManager';
